// config from railway
const runtime = window.__APP_CONFIG__ || process.env;
console.log(123546456479789);

console.log("APP_CONFIG runtime =>", window.__APP_CONFIG__);
export const appConfig = {
  NODE_ENV: runtime.NODE_ENV || "development",
  VUE_APP_DOMAIN:
    runtime.VUE_APP_DOMAIN || "https://5t8z5pcj-8080.asse.devtunnels.ms/",
  VUE_APP_TRANSACTION_API:
    runtime.VUE_APP_TRANSACTION_API ||
    "https://api-middleware-dev.dosetech.co/api/transactioncode/redeem",
  VUE_APP_API:
    runtime.VUE_APP_API || "https://api-hourglass-mobile-dev.dosetech.co",
  VUE_APP_API_KEY: runtime.VUE_APP_API_KEY || "CEGAChAtA7Ds40p",
  VUE_APP_LIFF_ID_LOGIN: runtime.VUE_APP_LIFF_ID_LOGIN || "1656234832-aVEwVwlK",
  VUE_APP_LIFF_URL:
    runtime.VUE_APP_LIFF_URL || "https://liff.line.me/1656234832-aVEwVwlK",
  VUE_APP_BRAND: runtime.VUE_APP_BRAND || "D-CRM",
  VUE_APP_THEME_API:
    runtime.VUE_APP_THEME_API ||
    "https://api-hourglass-campaign-dev.dosetech.co/api/Setting/theme",
  VUE_APP_ADDRESS_API:
    runtime.VUE_APP_ADDRESS_API || "https://api-address-dev.dosetech.co/api",
  VUE_APP_MODE: runtime.VUE_APP_MODE || "DEV",
  VUE_APP_LOGGER_API:
    runtime.VUE_APP_LOGGER_API || "https://api-crm-logger-dev.dosetech.co/api"
};
